'use strict';

var GridDateReoptButtonDirective = function GridDateReoptButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-date-reopt-button.html'),
    controller: 'GridDateReoptButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows) {
        $scope.onRowSelection(event, selectedRows, gridId, allRows);
      });
    }
  };
};
GridDateReoptButtonDirective.$inject = [];
module.exports = GridDateReoptButtonDirective;